import React from 'react';

const ConnectionCardSkeleton = () => {
    return (
        <div className="bg-gray-800/50 p-4 rounded-lg flex flex-col justify-between border border-gray-700/50 animate-pulse">
            <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-gray-700"></div>
                <div className="flex-grow">
                    <div className="h-4 bg-gray-700 rounded w-3/4 mb-2"></div>
                    <div className="h-3 bg-gray-700 rounded w-1/2"></div>
                </div>
            </div>
            <div className="flex items-center gap-2 justify-end">
                <div className="h-8 w-24 bg-gray-700 rounded-md"></div>
                <div className="h-8 w-10 bg-gray-700 rounded-md"></div>
            </div>
        </div>
    );
};

export default ConnectionCardSkeleton;
